module.exports = __webpack_public_path__ + "static/media/beep-07.d932c606.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beep-07.mp3
// module id = 58
// module chunks = 0